import { TfUserModelInterface } from "./interfaces/tf-user-model.interface";

export class TfUserModel implements TfUserModelInterface {
    isLoggedIn = false;
    countryCode = null;
    currencyCode = "";
    languageCode = null;
    shipToNumber = null;
    userId = null;
    userName = "";
    isAnonymous = true;
    isB2BMasterUser = false;
    userType = "b2c";
    isCrmManager = false;
    isSosManager = false;

    constructor(JSONdata: TfUserModelInterface) {
        this.setUserInfo(JSONdata);
    }

    setUserInfo(JSONdata: TfUserModelInterface) {
        Object.keys(JSONdata).forEach(key => {
            if (JSONdata[key]) this[key] = JSONdata[key];
        });
    }

    setIsLoggedIn(value: boolean) {
        this.isLoggedIn = value;
    }

    setCountryCode(code: string) {
        this.countryCode = code.trim();
    }

    setCurrencyCode(currency: string) {
        this.currencyCode = currency.trim();
    }

}
